import React from 'react'
import "./error.scss"
import { Link } from 'react-router-dom'

const Error = () => {
    return (
        <>
            <section className="error-section">
                <img src="\assets\error\error-bg.png" alt="img" className='img-fluid error-bg' />
                <div className="custom-container">
                    <div className="main-content">
                        <img src="\assets\error\error-img.svg" alt="img" className='img-fluid' />
                        <h4>404 - Page Not Found</h4>
                        <p>The page you’re trying to access doesn’t exist.</p>
                        <Link to="/" className='btn-return'>Return to Homepage</Link>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Error
